// 20.2.2.11 Math.clz32(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.math.clz32.js
// module id = 571
// module chunks = 0